var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "libinteractive-download panel panel-default" },
    [
      _c("div", { staticClass: "panel-heading" }, [
        _vm._v(_vm._s(_vm.T.outputOnlyFiles))
      ]),
      _c("div", { staticClass: "panel-body" }, [
        _c(
          "a",
          { staticClass: "btn btn-primary", attrs: { href: _vm.zipUrl } },
          [_vm._v(_vm._s(_vm.T.downloadZip))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }